<template>

  <div>
    <div :class="logisticContainerClass">
      <div class="panel-container">
        <!-- Header -->
        <div class="header-section">
          <div class="product-info">

            <div class="product-info-header">

              <button
                  type="button"
                  class="btn btn-primary btn-sm back-button"
                  @click="goBack"
                  aria-label="Powrót"
                  title="Powrót"
              >
                <span class="back-button-icon">←</span>
              </button>
              <div class="order-title-group">
                <span class="order-reference-badge">
                  {{ groupOrder.orderReference }}
                </span>

                <h2 class="order-name-title">
                  {{ groupOrder.orderName }}
                </h2>
              </div>
            </div>

            <div class="meta-row">
              <span><b>Data utw.:</b> {{ groupOrder.orderCreationDate }}</span>
              <span><b>Dostawca:</b> {{ currentSupplierDataFormData.name }}</span>
              <span><b>Do podziału: </b> {{ groupOrder.toDivide ? 'Tak' : 'Nie' }}</span>
              <span v-if="groupOrder.toDivide"><b>Apteka dzieląca:</b> {{
                  groupOrder.dividerMainDrugstoreClientId
                }}</span>

            </div>
          </div>
          <div class="drugstore-info">
            <div class="meta-row">
              <span>
                 <div class="btn btn-outline-info btn-sm items-management-btn"
                      @click="openOrderGeneratorDetailsModal"><i class="fas fa-list me-1"></i>Szczegóły [F2]  </div>
              </span>

              <span>
                <div class="btn btn-outline-info btn-sm items-management-btn"
                     @click="openOrderGeneratorProductsList"><i class="fas fa-box me-1"></i> Towary [F3]</div>
              </span>
              <span>
                 <div class="btn btn-outline-info btn-sm items-management-btn"
                      @click="openOrderGeneratorDrugstoresList">  <i class="fas fa-home me-1"></i> Apteki [F4]</div>
              </span>

              <span>
                    <div class="col-sm-12">
                        <button
                            class="btn btn-outline-primary btn-sm shadow-sm"
                            @click="openSellingRangesModal"
                        >
                          <i class="fas fa-calendar-alt me-1"></i> Zakresy sprzedaży [F5]
                        </button>
                    </div>
              </span>

              <span>
                    <div class="col-sm-12">
                      <button
                          class="btn btn-outline-info btn-sm "
                          @click="openDiscountsModal"
                      >
                        <i class="fas fa-tags me-1"></i> Rabaty [F6]
                      </button>
                    </div>
              </span>

              <span>
                 <div class="btn btn-outline-info btn-sm items-management-btn"
                      @click="openOrderItemImportModal">
                   <i class="fas fa-file-excel me-1"></i>
                   Importuj dane zamówienia [F7]
                 </div>
              </span>


            </div>
          </div>
        </div>

        <div class="actions-section" style="margin-top:4px;">
          <div class="col-sm-6">
            <div class="btn btn-link btm-sm"
                 @click="toggleLogisticContainerVisibility">
              {{ !isLogisticContainerOpen ? 'Pokaż panel towaru' : 'Ukryj panel towaru' }}
            </div>

            <BDropdown
                ref="settingAmountsDropdown"
                text="Ustaw ilości"
                v-model="isSettingAmountsOpen"
                variant="primary"
                size="sm"
                class="m-0"
                :disabled="groupOrder.publishedAt != null"
            >
              <BDropdownItem

                  v-for="(option,index) in settingAmountsAvailableOptions"
                  :key="option.key"
                  :ref="'settingAmountsAvailable'+index"
                  :id="'settingAmountsAvailable'+index"
                  @click="setLogisticValueForAll(option)"
              >
                {{ option.label }}
              </BDropdownItem>
            </BDropdown>


            <BDropdown
                text="Eksportuj do excel"
                variant="info"
                size="sm"
                class="m-2"
            >
              <template #button-content>
                <i class="fas fa-file-excel ms-1"/>
                Eksportuj do excel
              </template>
              <BDropdownItem

                  key="items-default-excel-export"
                  @click="exportToExcel(false)">
                Eksport zwykła
              </BDropdownItem>
              <BDropdownItem
                  key="items-flat-excel-export"
                  @click="exportToExcel(true)">
                Eksport siatka
              </BDropdownItem>
            </BDropdown>

            <button
                class="d-none d-sm-inline-block btn btn-sm btn-success shadow-sm"
                @click="exportAndSendEmail()"

            >
              <i class="fab fa-telegram-plane ms-1"/>
              Wyślij zamówienie do aptek (e-mail)
            </button>

          </div>

          <div class="col-sm-6 justify-end" style="padding-top:4px;">
            <div v-if="!currentGroupOrder.prospectCreationDate" style="margin-right: 8px;">

              <button

                  class="d-none d-sm-inline-block btn btn-sm btn-outline-success shadow-sm justify-end"
                  style="margin-left: 4px;"
                  @click="publishProspect()"

              >
                <i class="fas fa-sitemap ms-1"/>
                Opublikuj prospekt
              </button>

            </div>
            <div v-else>

              <div v-if="!currentGroupOrder.prospectCloseDate" class="alert alert-warning" role="alert"
                   style="padding: 4px;margin: unset;">
                <i class="mdi mdi-account-clock"></i> Prospekt otwarty:
                {{ getDateTime(currentGroupOrder.prospectCreationDate, true) }}
                <span>Ważny do: {{ getDateTime(currentGroupOrder.prospectExpiryDate, true) }}</span>
              </div>
              <div v-else class="alert alert-success" role="alert" style="padding: 4px;margin: unset;">
                <i class="fas fa-check-circle"></i> Prospekt zamknięty:
                {{ getDateTime(currentGroupOrder.prospectCloseDate, true) }}
              </div>


            </div>


            <div>
              <button
                  class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm justify-end"
                  style="margin-left: 4px;"
                  @click="goToPricing()"
              >
                <i class="fas fa-tags ms-1"/>
                Przejdź do wyceny
              </button>


            </div>


          </div>

        </div>

        <DraggableModal
            v-model="isLogisticContainerOpen"
            title="Panel towaru"
            icon="bx bx-bar-chart-square"
            width="600px"
            height="auto"
            :initialX="lastX"
            :initialY="lastY"
            @position-change="updateCoordinates"
            @close="handleClose"
        >
          <div class="p-1">
            <ProductLogisticDetailsSection2 :product="selectedProductData"
                                            :drugstore="selectedDrugstoreData"
                                            :stock="selectedProductStock"
                                            :selling="selectedProductSelling"
                                            :sellingDetails="selectedProductSellingDetails"
                                            :selectedItemData="selectedItemData"
                                            :lastStockDates="lastStockDates"
                                            @onContainerHide="closeLogisticContainer"
                                            @onContainerMounted="onShowLogisticContainer"
                                            @onSelectValue="logisticValueSelected"/>
          </div>
        </DraggableModal>


      </div>

    </div>
    <b-modal
        v-model="showSendMailModal"
        id="send-payment-doc-email-form-modal"
        scrollable
        :title=mailContent.sendMailDialogTitle
        title-class="font-18"
        size="xl"
        style="z-index:100010!important;"
        hide-footer


    >
      <b-alert
          v-model="showSendMailAlert"
          :variant="sendMailAlertType"
          class="mt-3"
          dismissible
      >{{ sendMailAlertContent }}
      </b-alert
      >

      <div class="form-group">

        <CommonEmailSendMessageForm
            :mailMessage="mailContent.mailMessage"
            :mailSubject="mailContent.mailSubject"
            :mailTo="mailContent.mailTo"
            :mailCc="mailContent.mailCc"
            :mailAttachmentName="mailContent.mailAttachmentName"
            @onCancelMail="showSendMailModal = false"
            @onSendMail="sendEmailWithPackageOrderData"
            :key="mailContent"


        />


      </div>


    </b-modal>

    <PackageProspectSettingsModal
        v-model:showModal="showProspectSettingsModal"
        :initialProspectData="initialProspectData"
        @onSaveProspectSettings="handleSaveProspectSettings"
    />

    <div v-if="showItemsImportModal">
      <PackageOrderItemImportWrapper
          ref="orderItemImportWrapper"
          :additionalFields="getDiscountsFields"
          :orderGroupGuid="groupOrder.groupGuid"
          @onClose="showItemsImportModal = false"
          @onImportSuccess="refreshList"

      />
    </div>


  </div>

</template>


<script>

import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import CommonEmailSendMessageForm from "@/components/widgets/CommonEmailSendMessageForm.vue";
import {BAlert, BModal, BDropdown, BDropdownItem} from "bootstrap-vue-next";
import {log} from "@/state/pinia/log";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import {packagesHelperMethods} from "@/views/PackagesManager/helper/packagesHelperMethods";
import Swal from "sweetalert2";
import router from "@/router";
import {usePackagesManagerModule} from "@/state/pinia/packagesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import {useLayoutStore} from "@/state/pinia/layout";
import ProductLogisticDetailsSection2 from "@/views/PackagesManager/ProductLogisticDetailsSection2.vue";
import DraggableModal from "@/components/widgets/DraggableModal.vue";
import PackageProspectSettingsModal from "@/views/PackagesManager/PackageProspectSettingsModal.vue";
import PackageOrderItemImportWrapper from "@/views/PackagesManager/PackageOrderItemImportWrapper.vue";
import dateFormat from "dateformat";

export default {
  name: "PackageOrderGeneratorDetailsSection",
  components: {
    PackageProspectSettingsModal,
    DraggableModal,
    ProductLogisticDetailsSection2,
    PackageOrderItemImportWrapper,

    BAlert, BModal, CommonEmailSendMessageForm, BDropdown, BDropdownItem
  },
  props: {
    groupOrder: {type: Object, required: true},
    selectedItemData: {type: Object, required: false},
    selectedProductData: {type: Object, required: false},
    selectedDrugstoreData: {type: Object, required: false},
    selectedProductStock: {type: Object, required: false},
    selectedProductSelling: {type: Object, required: false},
    lastStockDates: {type: Object, required: false},
    selectedProductSellingDetails: {type: Object, required: false},
    settingAmountsAvailableOptions: {type: Array, required: true},
    isEmpty: {type: Boolean, required: true},
    orderTableHeaders: {type: Array, required: true},
  },
  emits: ['openOrderGeneratorDetailsModal', 'openOrderGeneratorDrugstoresList',
    'openOrderGeneratorProductsList', 'onShowLogisticContainer', 'onSelectValue', 'onSetValueForAll', 'onOrderSentToPricing',
    'openSellingRangesModal', 'openDiscountsModal', 'onPublishProspect', 'onRefreshList'],
  data() {
    return {
      isLogisticContainerOpen: false,
      mailContent: {
        sendMailDialogTitle: "",
        mailMessage: "",
        mailSubject: "",
        mailTo: "",
        mailCc: "",
        mailAttachmentName: ""
      },
      showSendMailModal: false,
      showSendMailAlert: false,
      sendMailAlertType: "warning",
      sendMailAlertContent: "",
      currentSupplierDataFormData: {},
      lastX: 0,
      lastY: 0,
      showProspectSettingsModal: false,

      // Dane startowe (np. z API/store); wartości dat jako timestamp (ms)
      initialProspectData: {
        prospectExpiryDate: Date.now() + 7 * 24 * 60 * 60 * 1000,
        prospectCloseDate: null,
        prospectAllowModifyAmount: false,
        prospectAllowAddProducts: false,
        prospectAllowPurchasePrice: false,
      },
      showItemsImportModal: false,
      currentGroupOrder: this.groupOrder,
      isSettingAmountsOpen: false,

    };
  },
  computed: {
    packagesModule() {
      return usePackagesManagerModule();
    },
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
    layoutStore() {
      return useLayoutStore();
    },

    layout: {
      get() {
        return this.layoutStore.layoutType;
      },
      set(layout) {
        this.layoutStore.changeLayoutType(layout);
      }

    },
    logisticContainerClass() {
      if (this.layout === 'horizontal') {
        return 'logistic-container';
      } else {
        return 'logistic-container-vertical';
      }
    },
    getDiscountsFields() {
      // filter orderTableHeaders get only elements which key starts with packageDiscount_ and map to another structure like{key:key, lable:text, required:false, type:type)
      return this.orderTableHeaders.filter(header => header.key.startsWith("packageDiscount_")).map(header => {
        return {
          key: header.key,
          label: header.text,
          required: false,
          type: header.type === "number" ? "number" : "string"
        }
      });
    }

  },
  methods: {
    refreshList() {
      this.$emit('onRefreshList', true);
    },
    goBack() {
      this.$router.go(-1);

    },
    getDateTime(sourceValue, isEpochMilliseconds) {
      if (!isEpochMilliseconds) {
        return sourceValue;
      }

      if (!sourceValue || sourceValue == 0) {
        return "Brak daty";
      }

      var date = new Date(sourceValue); // The 0 sets the date to the epoch
      return dateFormat(date, "dd.mm.yyyy HH:MM:ss");

    },
    updateCoordinates(coordinates) {
      console.log("Current draggable modal coords:", coordinates)
    },
    handleClose(event) {
      console.log("Closing the draggable modal:", event)
    },


    async checkItemsBelowLogisticMinPerOrder() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      var response = await this.packagesModule.httpGetItemsBelowLogisticMinPerOrder({orderGroupGuid: this.groupOrder.groupGuid});
      this.lazyloaderModule.setDisplayLazyLoader(false);
      const itemsBelowMinPerOrder = response.data.payload;
      if (itemsBelowMinPerOrder && itemsBelowMinPerOrder.length > 0) {
        let message = "Nie można wysłać do realizacji. Następujące pozycje mają ilość poniżej minimalnej logistycznej na zamówienie:\n\n";
        itemsBelowMinPerOrder.forEach(item => {
          message += `-${item.listIndex}. ${item.name} (Ilość: ${item.amount}, Minimalna ilość logistyczna: ${item.logisticMinAmountPerOrder})\n`;
        });

        Swal.fire({
          title: "Pozycje poniżej minimalnej ilości logistycznej",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "OK",
          input: "textarea",
          inputPlaceholder: "Brak informacji",
          inputValue: message,
          customClass: {
            width: "850px!important",
            container: "swal-highest"
          },
          inputAttributes: {
            disabled: true
          }
        });

        return false;
      }
      return true;
    },

    async publishProspect() {
      const isOk = await this.checkItemsBelowLogisticMinPerOrder()
      if (!isOk) return;

      this.$emit('onPublishProspect', true);
      this.initialProspectData.prospectExpiryDate = this.groupOrder.prospectExpiryDate;
      this.initialProspectData.prospectCloseDate = this.groupOrder.prospectCloseDate;
      this.initialProspectData.prospectAllowModifyAmount = this.groupOrder.prospectAllowModifyAmount;
      this.initialProspectData.prospectAllowAddProducts = this.groupOrder.prospectAllowAddProducts;
      this.initialProspectData.prospectAllowPurchasePrice = this.groupOrder.prospectAllowPurchasePrice;
      this.openProspectSettings();

    },

    openProspectSettings() {
      this.showProspectSettingsModal = true;
    },

    handleSaveProspectSettings(settings) {
      // settings = {
      //   prospectExpiryDate: number|null,
      //   prospectCloseDate: number|null,
      //   prospectAllowModifyAmount: boolean,
      //   prospectAllowAddProducts: boolean,
      //   prospectAllowPurchasePrice: boolean
      // }

      // Przykład: zapis do API
      // await axios.post("/api/prospect/settings", settings);

      // Przykład: synchronizacja lokalnego stanu
      this.initialProspectData = {...this.initialProspectData, ...settings};
      console.log("Saved prospect settings:", this.initialProspectData);
      this.packagesModule.httpPublishProspect(
          {groupOrder: this.groupOrder});
      this.currentGroupOrder.prospectCreationDate = Date.now();

    },

    exportToExcel(flatExport) {
      packagesHelperMethods.exportGroupOrderToFile(this.groupOrder, "XLS", false, false, flatExport)
    },
    goToPricing() {
      Swal.fire({
        title: "Uwaga",
        text: "Czy na pewno chcesz przejść do etapu wyceny?",
        showCloseButton: true,
        showConfirmButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: "#556ee6",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Tak, przejdź do wyceny",
        cancelButtonText: "Nie",
        customClass: {
          container: "swal-highest"
        },
      }).then((proceed) => {
        if (proceed.isConfirmed) {
          router.push({
            name: "PackagesManagerOrdersGeneratorPricingStage",
            query: {editOrderGroupGuid: this.groupOrder.groupGuid}
          });
        }
      });
    },
    exportAndSendEmail() {
      packagesHelperMethods.exportGroupOrderToFile(this.groupOrder, "XLS", true, false, true).then((response) => {
        log.log(response);
        if (response.isConfirmed) {
          this.mailContent = {
            sendMailDialogTitle: response.sendMailDialogTitle,
            mailMessage: response.mailMessage,
            mailSubject: response.mailSubject,
            mailTo: response.mailTo,
            mailCc: response.mailCc,
            mailAttachmentName: response.mailAttachmentName
          }

          this.packagesModule.httpGetGroupOrderEMailHistory({orderGroupGuid: this.groupOrder.groupGuid}).then((response) => {
            if (response && response.data.payload.length > 0) {
              // get first of response.data.payload (ordered by send date)
              response.data.payload.sort((a, b) => new Date(b.sendDate) - new Date(a.sendDate));
              // getting last email
              const lastEmail = response.data.payload[0];

              this.showSendMailAlert = true;
              this.sendMailAlertType = "warning";
              this.sendMailAlertContent = "Wiadomość email z tym zamówieniem została już wysłana do aptek dnia " + packagesHelperMethods.formatDatetimeToLocaleFormat(lastEmail.sendDate);
            }

            this.showSendMailModal = true;
          })


        }
      });
    },
    sendEmailWithPackageOrderData(emailData) {
      log.log(emailData);
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Wysyłanie wiadomości email z zamówieniem...");

      var emailPayload = {
        mailMessage: emailData,
        orderGroupGuid: this.groupOrder.groupGuid
      }

      this.packagesModule.httpSendEmailWithWithGroupOrderData(emailPayload).then((response) => {
        this.showSendMailModal = false;
        return apiRequestsHelper.handleResponseWithDialogs(response, true);
      })

    },

    toggleLogisticContainerVisibility() {
      this.isLogisticContainerOpen = !this.isLogisticContainerOpen;
      if (!this.isLogisticContainerOpen) {
        this.$emit('onShowLogisticContainer', {isOpened: false, height: 0});
      }

    },
    logisticValueSelected(event) {
      this.$emit('onSelectValue', event);
    },

    setLogisticValueForAll(option) {
      this.$emit('onSetValueForAll', option);
    },
    onShowLogisticContainer(containerHeight) {
      log.log(containerHeight);
      this.$emit('onShowLogisticContainer', {isOpened: true, height: containerHeight});
    },
    closeLogisticContainer() {
      this.isLogisticContainerOpen = false;
    },
    openOrderGeneratorDetailsModal() {
      this.$emit('openOrderGeneratorDetailsModal', true)
    },
    openSellingRangesModal() {
      this.$emit('openSellingRangesModal', true)
    },
    // openDiscountRulesModal() {
    //   this.$emit('openDiscountRulesModal', true)
    // },
    openDiscountsModal() {
      this.$emit('openDiscountsModal', true)
    },

    openOrderGeneratorDrugstoresList() {
      this.$emit('openOrderGeneratorDrugstoresList', true);
    },
    openOrderGeneratorProductsList() {
      this.$emit('openOrderGeneratorProductsList', true);
    },
    openOrderItemImportModal() {
      console.log("openOrderItemImportModal", this.groupOrder)
      if (this.groupOrder.publishedAt) {
        Swal.fire({
          title: "Zamówienie zostało opublikowanie",
          text: "Nie możesz zmieniać danych w opublikowanym już zamówieniu.",
          icon: "warning",
          customClass: {
            container: "swal-highest"
          },
        })
        return
      }
      this.showItemsImportModal = true;

      // wait 100ms for modal to open and then call open method in PackageOrderItemImportWrapper component to initialize it
      setTimeout(() => {
        if (this.$refs.orderItemImportWrapper) {
          this.$refs.orderItemImportWrapper.open();
        }
      }, 200)


    },
    fetchSupplierData() {
      var payload = {
        guid: this.groupOrder.centralSupplierGuid,
      };
      this.commonModule.httpGetSupplierByGuid(payload).then((response) => {
        log.log(response);
        if (response) {
          this.currentSupplierDataFormData = JSON.parse(JSON.stringify(response.data.payload));
        }
      })
    },
    handleKeyDown(event) {
      const target = event.target;
      const tagName = target?.tagName?.toLowerCase();

      const isTypingElement =
          tagName === "input" ||
          tagName === "textarea" ||
          tagName === "select" ||
          target?.isContentEditable;

      if (isTypingElement) {
        return;
      }

      if (event.ctrlKey) {
        return
      }

      event.preventDefault()
      if (event.altKey) {
        this.handleKeyDownWithAlt(event);
      } else {
        this.handleKeyDownWithoutAlt(event);
      }

    },
    handleKeyDownWithAlt(event) {
      console.log("Alt pressed", event);
      const allowedKeys = ['F12', 'i']
      if (!allowedKeys.includes(event.key)) {
        return
      }
      event.preventDefault();
      switch (event.key) {
        case 'F12':
          this.toggleLogisticContainerVisibility();
          break
        case 'i':
          this.openSettingAmountsDropdown();
          break
      }

    },
    handleKeyDownWithoutAlt(event) {
      const allowedKeys = ['F2', 'F3', 'F4', 'F5', 'F6', 'F7']

      if (!allowedKeys.includes(event.key)) {
        return
      }

      event.preventDefault()

      switch (event.key) {
        case 'F2':
          this.openOrderGeneratorDetailsModal();
          break
        case 'F3':
          this.openOrderGeneratorProductsList();
          break
        case 'F4':
          this.openOrderGeneratorDrugstoresList()
          break
        case 'F5':
          this.openSellingRangesModal();
          break
        case 'F6':
          this.openDiscountsModal();
          break
        case 'F7':
          this.openOrderItemImportModal();
          break
      }
    },

    async openSettingAmountsDropdown() {
      if (this.groupOrder.publishedAt) return

      this.isSettingAmountsOpen = true
      await this.$nextTick()

      const root = this.$refs.settingAmountsDropdown?.$el
      if (!root) return
      root.focus();
    },

  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown)
  },

  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown)
  },
  created() {

    if (this.groupOrder && this.groupOrder.centralSupplierGuid) {
      this.currentGroupOrder = this.groupOrder;
      this.fetchSupplierData();
    }


    console.log("PackageOrderGeneratorDetailsSection created");
    console.log(this.isEmpty)
  }
};
</script>

<style scoped>
.logistic-container {
  font-family: "Segoe UI", Tahoma, sans-serif;
  font-size: 13px;
  color: #2b2b2b;
  transition: all 0.2s ease;
  position: fixed;
  top: 112px; /* or 0 if you don't have a header */
  left: 0;
  width: 100vw;
  z-index: 99;
  background: #f3f2f1;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 8px;
  padding-bottom: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.logistic-container-vertical {
  font-family: "Segoe UI", Tahoma, sans-serif;
  font-size: 13px;
  color: #2b2b2b;
  transition: all 0.2s ease;
  position: unset;
  top: 112px; /* or 0 if you don't have a header */
  left: 0;
  width: 100%;
  z-index: 99;
  background: #f3f2f1;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 8px;
  padding-bottom: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.show-logistic-container-btn {
  width: 100%;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;


}

.center-show {
  text-align: center;
}

.panel-container {
  background: #f3f2f1;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 6px;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #c8c6c4;
  padding-bottom: 8px;
}

.actions-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #c8c6c4;
  margin-bottom: 2px;
}

.product-info .product-info-header {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #0078D4;
}

.meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 12.5px;
  color: #3b3a39;
}

.drugstore-info h3 {
  font-size: 15px;
  font-weight: 600;
  color: #201f1e;
  margin-bottom: 4px;
}

.data-grid-compact {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
  gap: 16px;
}

.data-section {
  background: #ffffff;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  padding: 12px;
}

.section-title {
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 13.5px;
  color: #005A9E;
}

.grid-2col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 12px;
}

.grid-2col div {
  display: flex;
  justify-content: space-between;
  padding: 4px 8px;
  background: #f9f9f9;
  border: 1px solid #e1dfdd;
  border-radius: 3px;
}

.grid-2col span {
  font-weight: 500;
  color: #605e5c;
}

.grid-2col b {
  color: #0078D4;
  font-weight: 600;
}

.chart-box {
  margin-top: 10px;
  background: #f5f5f5;
  border: 1px solid #e1dfdd;
  border-radius: 3px;
  padding: 6px;
}

.product-data-placeholder {
  background: #f3f2f1;
  border: 1px dashed #c8c6c4;
  padding: 10px;
  border-radius: 4px;
  text-align: center;
  font-style: italic;
  font-size: 13px;
}

.justify-end {
  justify-content: flex-end !important;
  display: flex;
}

.product-info-header {
  margin-bottom: 10px;
}

.product-info-header .back-button,
.product-info-header h2 {
  display: inline-block;
  vertical-align: middle;
}

.product-info-header h2 {
  margin: 0 0 0 10px;
  font-size: 1.2rem;
  font-weight: 600;
  max-width: calc(100% - 56px);
  word-break: break-word;
}

.back-button {
  width: 38px;
  height: 24px;
  padding: 0;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
}


.back-button:active {
  transform: translateY(1px);
}

.back-button:focus-visible {
  outline: 2px solid #86b7fe;
  outline-offset: 2px;
}

.back-button-icon {
  font-size: 24px;
  line-height: 18px;
  font-weight: 600;
  display: inline-block;
}

.product-info-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  min-width: 0;
}

.order-title-group {
  display: flex;
  align-items: baseline;
  gap: 10px;
  min-width: 0;
  flex-wrap: nowrap;
}

.order-reference-badge {
  display: inline-block;
  flex-shrink: 0;
  padding: 2px 8px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  background: #ffffff;
  color: #605e5c;
  font-size:  1rem;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0.2px;
}

.order-name-title {
  margin: 0;
  min-width: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: #005A9E;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>

